import React from 'react'
import {PaymentCheckoutEwalletDetail} from '../containers'

export default function PaymentCheckoutEwalletDetailScreen() {
  return <PaymentCheckoutEwalletDetail />
}
